const paginationStyling = {
  '.MuiTablePagination-toolbar': {
    justifyContent: {
      xs: 'space-between',
      sm: 'flex-end',
    },
  },
  '.MuiInputBase-root': {
    margin: {
      xs: 0,
      sm: 'initial',
    },
  },
  '.MuiTablePagination-spacer': {
    display: {
      xs: 'none',
      sm: 'block',
    },
  },
  '.MuiTablePagination-displayedRows': {
    display: {
      xs: 'none',
      sm: 'block',
    },
  },
};

export { paginationStyling };
